import deliveries from "@/business/deliveries/infrastructure/config/deliveries.json";
import { Delivery, DeliveryActions } from "../../domain/deliveries";

export const getAllDeliveriesService = {
    async execute(): Promise<Delivery[]> {
        const allDeliveries = deliveries;

        return new Promise((resolve) => {
            resolve(
                allDeliveries.map((delivery) => {
                    return DeliveryActions().deliveryInfo(
                        delivery.deliveryId,
                        delivery.client,
                        delivery.name,
                        delivery.message,
                        null,
                        null,
                        delivery.deliveryDate,
                    );
                })
            );
        });
    },
};
